module.exports = __webpack_public_path__ + "img/matt_h_2.5972121d.png";